import React from "react";

// Components
// import { Gap, Header, HelpBar, useFirebase } from "../../components";
// import Manage from "./Manage";
import Aplikasi from "./aplikasi";
import Toko from "./toko";
// import Sent from "./sent";
// import Received from "./received";

// react-router-dom
import { useHistory, Switch, Route, Redirect } from "react-router-dom";

// Material-UI
import { Tab, Tabs, Paper, Container } from "@material-ui/core";

// Styles
import useStyles from "./styles";

// React-Helmet
import { Helmet } from "react-helmet";
import Header from "../../../components/molecules/Header";
import Gap from "../../../components/atoms/Gap";

export default function Notification(props) {
  const { location } = props;

  const classes = useStyles();

  const history = useHistory();

  const handleChange = (event, value) => {
    history.push(value);
  };

  // const toko = `Toko ${
  //   subdomain.charAt(0).toUpperCase() + subdomain.slice(1)
  // } | Transaksi`;

  return (
    <>
      <Helmet>
        {/* <title>{toko}</title> */}
      </Helmet>
      <Container
        maxWidth="md"
        classes={{ root: classes.container }}
        className={classes.mainContainer}
      >
        <Header
          type="with-title-cart"
          title="Notifikasi"
        />
        <Gap height={60} />
        <Paper square variant="outlined">
          <Tabs
            textColor="primary"
            indicatorColor="primary"
            value={location.pathname}
            onChange={handleChange}
            variant="fullWidth"
          >
            <Tab
              style={{ textTransform: "capitalize" }}
              fullWidth
              label="Aplikasi"
              value="/notification/aplikasi"
            />
            <Tab
              style={{ textTransform: "capitalize" }}
              fullWidth
              label="Toko Saya"
              value="/notification/toko"
            />
          </Tabs>
        </Paper>
        <Switch>
          {/* <Route path="/transaksi/not-paid" component={Manage} /> */}
          <Route path="/notification/aplikasi" component={Aplikasi} />
          <Route path="/notification/toko" component={Toko} />
          {/* <Route path="/transaksi/sent" component={Sent} /> */}
          {/* <Route path="/transaksi/received" component={Received} /> */}
          <Redirect to="/notification/aplikasi" />
        </Switch>
        {/* <HelpBar /> */}
      </Container>
    </>
  );
}
